import React from 'react';
import { Layout, Typography } from 'antd';

const { Header, Content, Footer } = Layout;
const { Title } = Typography;

function LayoutPublic({ children }) {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header
        style={{
          background: '#001529',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Title level={3} style={{ color: '#fff', margin: 0 }}>
          VIP Links Hub
        </Title>
      </Header>

      <Content style={{ padding: '24px' }}>{children}</Content>

      <Footer style={{ textAlign: 'center' }}>
        Desenvolvido por você ⚡ Umbrella
      </Footer>
    </Layout>
  );
}

export default LayoutPublic;
